import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
}

export interface HasToDeleteDocumentComponent extends ComponentCanDeactivate {
  showConfirmation(): boolean | Observable<boolean>;
}

export const deleteDocumentGuard: CanDeactivateFn<HasToDeleteDocumentComponent> = (
  component: HasToDeleteDocumentComponent,
) => {
  if (component.canDeactivate()) {
    return true;
  }

  return component.showConfirmation();
};
